/** Local Y.Doc cache for instant wave reopen (web: localStorage). */
import { materializeBlocksFromYjsSnapshot } from "./waveHydration.js";
/** Conteggio blocchi cache: campo persistito se presente (entry legacy: materializzazione una tantum). */
export function cacheEntryBlocksCount(entry) {
    if (typeof entry.blocksCount === "number" && entry.blocksCount >= 0) {
        return entry.blocksCount;
    }
    return materializeBlocksFromYjsSnapshot(entry.snapshotB64).length;
}
const PREFIX = "wave:doc:";
function cacheKey(waveId) {
    return `${PREFIX}${waveId}`;
}
export function readWaveDocumentCache(waveId) {
    if (typeof localStorage === "undefined")
        return null;
    const raw = localStorage.getItem(cacheKey(waveId));
    if (!raw)
        return null;
    try {
        const entry = JSON.parse(raw);
        if (!entry.snapshotB64?.trim())
            return null;
        if (typeof entry.appliedSeq !== "number")
            return null;
        return entry;
    }
    catch {
        return null;
    }
}
/**
 * Use cache when it is at least as fresh as the wave metadata snapshot seq.
 * `serverBlocksCount` precomputato evita di rimaterializzare lo snapshot server
 * quando il chiamante lo ha già contato (connect ne fa più usi).
 */
export function isWaveDocumentCacheUsable(entry, waveSnapshotSeq, serverSnapshotB64, serverBlocksCount) {
    if (entry.appliedSeq < waveSnapshotSeq)
        return false;
    if (!serverSnapshotB64?.trim())
        return true;
    const cacheBlocks = cacheEntryBlocksCount(entry);
    const serverBlocks = serverBlocksCount ??
        materializeBlocksFromYjsSnapshot(serverSnapshotB64).length;
    return cacheBlocks >= serverBlocks;
}
export function writeWaveDocumentCache(waveId, entry) {
    if (typeof localStorage === "undefined")
        return;
    try {
        localStorage.setItem(cacheKey(waveId), JSON.stringify(entry));
    }
    catch {
        /* quota / private mode */
    }
}
export function clearWaveDocumentCache(waveId) {
    if (typeof localStorage === "undefined")
        return;
    localStorage.removeItem(cacheKey(waveId));
}
